import React, { useCallback, useContext } from "react"

import { Attendee } from "amazon-chime-sdk-js"

import useScrollToBottom from "hooks/useScrollToBottom"

import useChimeCaptions from "components/ChimeMeetingHooks/useChimeCaptions"

import CloudroomContext from "../CloudroomContext"

const CaptionRail: React.FC = () => {
  const { audioVideo, getInfoForExternalUserId } = useContext(CloudroomContext)

  const buildSpeakerLabel = useCallback(
    (attendee?: Attendee) =>
      getInfoForExternalUserId?.(attendee?.externalUserId)?.fullName ||
      "Participant",
    [getInfoForExternalUserId]
  )
  const { captionChunks } = useChimeCaptions({ audioVideo, buildSpeakerLabel })

  const scrollRef = useScrollToBottom<HTMLDivElement>(captionChunks)

  return (
    <div
      ref={scrollRef}
      className="max-h-32 flex-shrink-0 overflow-y-auto border-t border-white/10 bg-black/75 px-3 py-3 text-left text-base leading-relaxed text-white/95"
      role="log"
      aria-live="polite"
    >
      {captionChunks.length === 0 ? (
        <span className="text-white/50">Captions will appear here</span>
      ) : (
        captionChunks.map(chunk => (
          <p key={String(chunk.resultId)} className="mb-2 last:mb-0">
            <span className="font-semibold text-white">
              {chunk.speakerLabel}
              {": "}
            </span>
            <span>{chunk.text}</span>
          </p>
        ))
      )}
    </div>
  )
}

export default CaptionRail
